import useI18nNamespaceReg from '~/hooks/useI18nNamespaceReg';
import DICTIONARIES from '../translations';

const TRANSLATIONS_NAMESPACE = 'auth';

interface IUseNamespacedTranslationProp {
  skipSetDefaultNamespace?: boolean;
}

export default function useNamespacedTranslation({
  skipSetDefaultNamespace,
}: IUseNamespacedTranslationProp = {}) {
  return useI18nNamespaceReg({
    dictionaries: DICTIONARIES,
    namespace: TRANSLATIONS_NAMESPACE,
    skipSetDefaultNamespace,
  });
}
